"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

require("./index.css");

var ProgressBar = function (_a) {
  var dataTestId = _a.dataTestId,
      total = _a.total,
      current = _a.current;
  var percentage = current / total * 100;
  var information = current + "/" + total + " Completed";
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "progress-bar",
    "data-testid": dataTestId,
    "data-current": current,
    "data-total": total
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "progress-info"
    }, {
      children: information
    }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "progress-container"
    }, {
      children: (0, jsx_runtime_1.jsx)("div", {
        className: "progress-indicator " + (percentage === 100 ? 'progress-complete' : ''),
        style: {
          width: percentage + "%"
        }
      }, void 0)
    }), void 0)]
  }), void 0);
};

ProgressBar.propTypes = {
  dataTestId: prop_types_1.string,
  total: prop_types_1.number.isRequired,
  current: prop_types_1.number.isRequired
};
ProgressBar.defaultProps = {
  dataTestId: 'progress-bar'
};
exports.default = ProgressBar;